<template>
    <Card :title="$t('labels.deliveries')">
        <div class="card-body">
            <div class="row">
                <div class="col-4">
                    <FormGroup :label="$t('labels.create_company_number_statuses')">
                        <AppMultiselect
                            v-model="createCompanyNumberStatuses"
                            :options="crmStatusesList"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered table-fixed">
                <thead>
                    <tr>
                        <th width="50%">{{ $t('labels.delivery_service_status') }}</th>
                        <th width="50%">{{ $t('labels.order_status') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="deliveryStatus in deliveryStatuses" :key="deliveryStatus.value">
                        <td>{{ $t(`delivery_status.${deliveryStatus.value}`) }}</td>
                        <td>
                            <AppSelect
                                :options="crmStatusesList"
                                :selected-value="crmStatuses[selectedOrderStatusByDeliveryStatus[deliveryStatus.value]]?.name || null"
                                :model-value="selectedOrderStatusByDeliveryStatus[deliveryStatus.value]"
                                :can-be-empty="true"
                                @update:model-value="selectOrderStatus($event, deliveryStatus.value)"
                            >
                                <template #option-item="{option}">
                                    {{ option.name }}
                                </template>
                            </AppSelect>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="indigo" @click="save">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.save') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import AppButton from "../../../../../components/new/button/AppButton.vue";
import AppSelect from "../../../../../components/new/form/select/AppSelect.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import AppMultiselect from "../../../../../components/new/form/autocomplete/AppMultiselect.vue";

import { DeliveryStatusEnum } from "../../../../enums/DeliveryStatusEnum";
import { OrderStatusDeliveryServiceActionEnum } from "../../../../enums/OrderStatusDeliveryServiceActionEnum";
import { httpClient } from "../../../../../services/HttpClient";
import MessageNotificator from "../../../../../services/MessageNotificator";

export default {
    name: "DeliveryCard",
    components: {
        Card, AppButton, AppSelect, FormGroup, AppMultiselect
    },
    data() {
        return {
            deliveryStatuses: Object.values(DeliveryStatusEnum).map(value => ({ value })),
            selectedOrderStatusByDeliveryStatus: {},
            crmStatuses: {},
            createCompanyNumberStatuses: []
        }
    },
    computed: {
        crmStatusesList() {
            return Object.values(this.crmStatuses);
        }
    },
    methods: {
        fetchDeliveryMatrix() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/delivery-integration-statuses`).then(response => {
                const selected = {};
                for (const item of response.data.data) {
                    selected[item.status_type] = item.order_status_uuid;
                }
                this.selectedOrderStatusByDeliveryStatus = selected;
            });
        },
        selectOrderStatus(status, deliveryStatusValue) {
            if (!status) {
                delete this.selectedOrderStatusByDeliveryStatus[deliveryStatusValue];
                return;
            }

            this.selectedOrderStatusByDeliveryStatus[deliveryStatusValue] = status.uuid;
        },
        actionOnDeliveryServiceFor(status) {
            if (this.createCompanyNumberStatuses.some(item => item.uuid === status.uuid)) {
                return OrderStatusDeliveryServiceActionEnum.CREATE_COMPANY_NUMBER;
            }

            return null;
        },
        saveDeliveryMatrix() {
            const requestData = Object.entries(this.selectedOrderStatusByDeliveryStatus).map(([deliveryStatusValue, orderStatusUuid]) => ({
                status_type: deliveryStatusValue,
                order_status_uuid: orderStatusUuid
            }));

            return httpClient.put(`/projects/${this.$route.params.projectUuid}/delivery-integration-statuses`, {
                data: requestData
            });
        },
        saveCrmStatusActions() {
            return this.crmStatusesList.map(status => httpClient.patch(`/projects/${this.$route.params.projectUuid}/crm/statuses/${status.uuid}`, {
                action_on_delivery_service: this.actionOnDeliveryServiceFor(status)
            }));
        },
        async save() {
            await Promise.all([this.saveDeliveryMatrix(), ...this.saveCrmStatusActions()]).then(() => {
                new MessageNotificator().success(this.$t('alerts.success'));
            });
        },
        fetchCrmStatuses() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/statuses`, {
                orders: [{ column: 'priority_order', dir: 'asc' }],
                limit: 100
            })
            .then(response => {
                const statuses = {};
                response.data.data.forEach(status => {
                    statuses[status.uuid] = status;
                });
                this.crmStatuses = statuses;
                this.createCompanyNumberStatuses = response.data.data.filter(status => status.action_on_delivery_service === OrderStatusDeliveryServiceActionEnum.CREATE_COMPANY_NUMBER);
            });
        }
    },
    created() {
        this.fetchDeliveryMatrix();
        this.fetchCrmStatuses();
    }
}
</script>
